export const getCalensoLinkFromId = (calensoAppointmentId: string) => {
	return `https://dashboard.calenso.com/appointments/${calensoAppointmentId}`;
};
